// External libraries
import { Component } from "react";

// Kendo React components
import { Label } from "@progress/kendo-react-labels";

export class TableIndexField extends Component {
  constructor({ field, value, eventIndex, handleFieldChange }) {
    super();
    const { fieldName, properties } = field;

    this.state = {
      value: value, // Value pre-calculated by parent TableField
    };

    this.fieldName = typeof eventIndex === "number" ? `${fieldName}_${eventIndex}` : fieldName;
    this.fontSize = properties?.fontSize || "12";
    this.fontWeight = properties?.fontWeight || "normal";
    this.prefix = properties?.Prefix || "";
    this.style = {
      fontSize: `${this.fontSize}px`,
      fontWeight: this.fontWeight,
      marginTop: "auto",
      marginBottom: "auto",
    };
    this.handleFieldChange = handleFieldChange;
  }

  //#region lifecycle functions
  shouldComponentUpdate(_, nextState) {
    return this.state.value !== nextState.value;
  }

  componentDidMount() {
    if (this.state.value === "" || this.state.value === undefined || this.state.value === null) {
      console.warn(`TableIndexField: No pre-calculated value provided for ${this.fieldName}.`);
      this.setState({ value: 0 });
    }
  }

  componentDidUpdate() {
    this.handleFieldChange({
      e: {
        target: {
          name: this.fieldName,
          value: this.state.value,
        },
        value: this.state.value,
      },
    });
  }
  //#endregion lifecycle functions

  render() {
    return (
      <Label
        data-testid={this.fieldName}
        style={this.style}
        id={this.fieldName}
        name={this.fieldName}
      >
        {this.prefix + this.state.value}
      </Label>
    );
  }
}
